<template>
  <div>
    <VendorAccountSidebar
      name="vendor-account-sidebar"
      :banks="banks"
      :vendorId="vendorId"
      :data="vendorAccount"
      @success="getAccounts()"
    />
    <vs-table :data="filteredList">
      <template slot="header">
        <vs-row>
          <vs-col vs-xs="12" vs-sm="1" vs-lg="1" class="px-2">
            <vx-tooltip :text="$t('add') | capitalize">
              <vs-button
                color="success"
                icon-pack="feather"
                icon="icon-plus"
                type="filled"
                class="w-full my-4"
                @click="openSidebar()"
              >
                <!-- <span>{{ $t('add') }}</span> -->
              </vs-button>
            </vx-tooltip>
          </vs-col>

          <vs-col vs-xs="12" vs-sm="11" vs-lg="11" style="display: inline-flex">
            <div class="con-input-search vs-table--search">
              <input
                class="input-search vs-table--search-input mt-1"
                type="text"
                v-model="search"
              />
              <vs-icon icon="search"></vs-icon>
            </div>
          </vs-col>
        </vs-row>
      </template>
      <template slot="thead">
        <th>{{ $t('account_number') | capitalize }}</th>
        <th>{{ $t('bank') | capitalize }}</th>
        <th>{{ $t('currency') | capitalize }}</th>
        <th style="text-align: end">{{ $t('actions') | capitalize }}</th>
      </template>
      <template slot-scope="{ data }">
        <vs-tr :key="i" v-for="(tr, i) in data">
          <vs-td>
            {{ data[i].number }}
          </vs-td>
          <vs-td> {{ data[i].short_name }} - {{ data[i].name }} </vs-td>
          <vs-td>
            {{ data[i].currency }}
          </vs-td>
          <vs-td style="float: right">
            <action-icon
              icon="EditIcon"
              :tooltip="$t('edit')"
              v-if="hasPermission(['IU VENDORS EDIT'])"
              @click="openSidebar(data[i])"
            />
            <action-icon
              icon="TrashIcon"
              :tooltip="$t('delete')"
              v-if="hasPermission(['IU VENDORS EDIT'])"
              @click="confirmDelete(data[i])"
            />
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>
import ActionIcon from '@/views/qb-components/actions/ActionIcon'
import vSelect from 'vue-select'
import request from '../request'
import VendorAccountSidebar from './VendorAccountSidebar.vue'
import loading from '@/mixins/Loading'
export default {
  props: ['vendorId'],
  mixins: [loading],
  components: {
    ActionIcon,
    'v-select': vSelect,
    VendorAccountSidebar,
  },
  data() {
    return {
      search: '',
      vendorAccount: {},
      accounts: [],
      banks: [],
      currencies: [
        { value: 'MXN', label: 'MXN' },
        { value: 'USD', label: 'USD' },
      ],
      loading: {
        banks: false,
        accounts: false,
        submit: false,
      },
    }
  },
  computed: {
    isLoading() {
      return this.loading.banks || this.loading.accounts || this.loading.submit
    },
    filteredList() {
      return this.accounts.filter((item) => {
        return  item.short_name.toLowerCase().includes(this.search.toLowerCase()) || item.name.toLowerCase().includes(this.search.toLowerCase()) || item.number.toLowerCase().includes(this.search.toLowerCase())
      })
    },
  },
  methods: {
    getBanks() {
      this.loading.banks = true
      request
        .getBanks()
        .then((response) => {
          this.banks = [...response.data.banks]
          this.loading.banks = false
        })
        .catch((response) => {
          this.loading.banks = false
          this.showValidationErrors(response)
        })
    },
    getAccounts() {
      this.loading.accounts = true
      request
        .getAccounts(this.vendorId)
        .then((response) => {
          this.accounts = [...response.data.accounts]
          this.loading.accounts = false
        })
        .catch((response) => {
          this.loading.accounts = false
          this.showValidationErrors(response)
        })
    },
    confirmDelete(data) {
      this.vendorAccount = { ...data }
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: this.$i18n.messages[this.$i18n.locale].confirm,
        text: this.$i18n.messages[this.$i18n.locale].confirm_message,
        acceptText: this.$i18n.messages[this.$i18n.locale].delete,
        cancelText: this.$i18n.messages[this.$i18n.locale].cancel,
        accept: this.deleteAccount,
      })
    },
    deleteAccount() {
      this.loading.submit = true
      request
        .deleteAccount(this.vendorAccount.account_id, this.paydayId)
        .then((response) => {
          this.loading.submit = false
          this.$vs.notify({
            color: 'success',
            title: 'Success',
            text: 'Account Deleted',
          })
          this.getAccounts()
        })
        .catch((response) => {
          this.loading.submit = false
          this.showValidationErrors(response)
        })
    },
    openSidebar(data = {}) {
      this.vendorAccount = { ...data }
      this.$store.dispatch('toggleSidebar', 'vendor-account-sidebar')
    },
  },
  mounted() {
    this.getBanks()
    this.getAccounts()
  },
  watch: {
    isLoading(val) {
      if (val) {
        this.openLoading('vendor-details-loading')
      } else {
        this.closeLoading('vendor-details-loading')
      }
    },
  },
}
</script>

<style>
.vs-table--not-data {
  display: none !important;
}
</style>